import {combineReducers} from "redux";
import {ICardsMiniGameState} from "./cards/types";
import {IChestMiniGameState} from "./chests/types";
import {cardsReducer} from "./cards/reducer";
import {chestsReducer} from "./chests/reducer";
import {all} from "redux-saga/effects";
import chestGameSaga from "./chests/sagas";
import cardsGameSaga from "./cards/sagas";
import forkWithErrHandler from "../../shared/utils/forkWithErrHandler";

export interface IMiniGamesState {
    cards: ICardsMiniGameState,
    chests: IChestMiniGameState
}

export const miniGamesReducer = combineReducers<IMiniGamesState>({
    cards: cardsReducer,
    chests: chestsReducer
});

export function* miniGamesSaga() {
    yield all([
        forkWithErrHandler("miniGamesSaga", "cardsGameSaga", cardsGameSaga),
        forkWithErrHandler("miniGamesSaga", "chestGameSaga", chestGameSaga)
    ]);
}